/**
 * Generated from StartScreenLayout.fla
 */
export function StartScreenLayout(this: IStartScreenLayout) {
	const main = this.main;
	StartScreenLayout_main.call(this.main);
	main.x = 1024;
	main.y = 768;
	if (main.onLayout) main.onLayout();
	return this;
}
export function StartScreenLayout_main(this: IStartScreenLayout_main) {
	const buttonPlay = this.buttonPlay;
	StartScreenLayout_buttonPlay.call(this.buttonPlay);
	buttonPlay.x = -11.9;
	buttonPlay.y = 467.35;
	buttonPlay.width = 346.00;
	buttonPlay.height = 344.00;
	if (buttonPlay.onLayout) buttonPlay.onLayout();
	const loader = this.loader;
	StartScreenLayout_loader.call(this.loader);
	loader.x = -11.4;
	loader.y = 467.35;
	loader.width = 323.00;
	loader.height = 322.00;
	if (loader.onLayout) loader.onLayout();
	return this;
}
function StartScreenLayout_buttonPlay(this: IStartScreenLayout_buttonPlay) {
	if (this.setLayoutTexture) this.setLayoutTexture("button-play.png", 0.500, 0.500);
	return this;
}
function StartScreenLayout_loader(this: IStartScreenLayout_loader) {
	if (this.setLayoutTexture) this.setLayoutTexture("loader.png", 0.502, 0.500);
	return this;
}
interface IStartScreenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IStartScreenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IStartScreenLayoutSprite extends IStartScreenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IStartScreenLayoutText extends IStartScreenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IStartScreenLayoutPolygon extends Array<number> {
}
interface IStartScreenLayout {
	readonly main: IStartScreenLayout_main;
}
interface IStartScreenLayout_main extends IStartScreenLayoutContainer {
	readonly buttonPlay: IStartScreenLayout_buttonPlay;
	readonly loader: IStartScreenLayout_loader;
}
interface IStartScreenLayout_buttonPlay extends IStartScreenLayoutSprite {
}
interface IStartScreenLayout_loader extends IStartScreenLayoutSprite {
}
